import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Feeds } from 'src/app/models/feeds';
import { JobOpeningsVo } from 'src/app/models/jobOpenings';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(private http: HttpClient) { }

  feeds:Feeds[] = [];
  jobOpenings:JobOpeningsVo[] = [];
  imageUrl: any = "https://codingislove.com/wp-content/uploads/2015/12/codinglovenew.png";

  ngOnInit(): void {
    this.loadData();
  }


  getFeedsListCall() {
    return this.http.get("https://3898i2a7t4.execute-api.us-west-1.amazonaws.com/default/getFeedList");
  }

  getJobOpeningsListCall() {
    return this.http.get("https://gizcv5lgqmwykti2kbx6py76wq0lildi.lambda-url.us-west-1.on.aws/");
  }

  loadData(){
    // this.getFeedsListCall()
    //   .subscribe(data => {
    //    let responce : any = data;
    //    let listData = responce.body.Items;
    //    listData.sort(function(a:any,b:any){
    //     return b.createdDate - a.createdDate
    //    });
    //    listData =  listData.filter((item: any) => item.isDeleted != true);

    //    this.feeds = listData;
    //   //  this.selectedField = this.feeds[0];
    //   });

      this.getJobOpeningsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;
       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);

       this.jobOpenings = listData;
      });
    }

    isMetadataAvailable(obj: any):boolean {
      if(obj && obj.linkMetaData && obj.linkMetaData.image) {
        return true;
      }
      return false;
    }
    
  isMetadataAvailableWithoutImage(obj: any):boolean {
    if(obj && obj.linkMetaData) {
      return true;
    }
    return false;
  }
}
